'use client'
import { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'

import { messageStore } from '@/store/Message.store'

import { Popup } from '@/components/Popup'

import styles from './Message.module.scss'

type MessageProps = {
  className?: string
}
export const Message: FunctionComponent<MessageProps> = observer(
  ({ className }) => {
    if (!messageStore.visible) {
      return null
    }

    return (
      <Popup onClose={messageStore.hide} className={className}>
        <div className={styles.title}>{messageStore.title}</div>
        {messageStore.description.length > 0 ? (
          <div className={styles.description}>{messageStore.description}</div>
        ) : null}
      </Popup>
    )
  }
)
